import { useOktaAuth } from "@okta/okta-react";
import { appConfig, isOktaConfigured } from "../app/config/appConfig";
import { clearLogoutInitiated, isLogoutInitiated, markLogoutInitiated } from "../app/okta/logoutState";

export const redirectToOverview = () => {
  window.location.assign(ROOT_REDIRECT_TARGET);
};

const ROOT_REDIRECT_TARGET = "/";
const getPostLogoutRedirectUri = () =>
  `${window.location.origin}${appConfig.oktaLogoutCallbackPath}`;

const clearOktaLocalStorageKeys = () => {
  try {
    const keysToRemove = [];

    for (let index = 0; index < localStorage.length; index += 1) {
      const key = localStorage.key(index);

      if (key?.startsWith("okta-")) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => localStorage.removeItem(key));
  } catch {
    // localStorage unavailable (e.g., incognito mode)
  }
};

const clearOktaSessionStorageKeys = () => {
  try {
    const keysToRemove = [];

    for (let index = 0; index < sessionStorage.length; index += 1) {
      const key = sessionStorage.key(index);

      if (key?.startsWith("okta-")) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // sessionStorage unavailable
  }
};

const finishClientSideLogout = (redirect) => {
  clearOktaLocalStorageKeys();
  clearOktaSessionStorageKeys();
  clearLogoutInitiated();
  redirect();
};

const useLogOut = ({ redirect = redirectToOverview } = {}) => {
  const { oktaAuth } = useOktaAuth();

  return async () => {
    if (!isLogoutInitiated()) {
      markLogoutInitiated();
    }

    if (isOktaConfigured && oktaAuth?.signOut) {
      try {
        oktaAuth.tokenManager?.clear?.();
        await oktaAuth.signOut({
          postLogoutRedirectUri: getPostLogoutRedirectUri(),
          clearTokensBeforeRedirect: true,
          revokeAccessToken: true,
          revokeRefreshToken: true,
        });

        finishClientSideLogout(redirect);
        return;
      } catch (_error) {
        oktaAuth.tokenManager?.clear?.();
        try {
          await oktaAuth.closeSession?.();
        } catch {
          // fall back to local cleanup when okta session close fails
        }
      }
    }

    finishClientSideLogout(redirect);
  };
};

export default useLogOut;
